import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

const MainLayout = ({ onLogout }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Sprawdzanie rozmiaru ekranu przy ładowaniu i zmianie rozmiaru okna
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setIsSidebarOpen(false); // Zamykamy sidebar na większych ekranach
      }
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  // Zamykanie sidebara po kliknięciu poza nim na urządzeniach mobilnych
  const handleOverlayClick = () => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <div className="flex h-full relative">
      {/* Mobilna nawigacja */}
      {isMobile && (
        <div className="fixed top-0 left-0 right-0 h-16 bg-white border-b border-neutral-200 z-20 flex items-center justify-between px-4">
          <span className="text-lg font-semibold text-primary-600">Klint</span>
          <button 
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="p-2 rounded-md hover:bg-neutral-100"
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>
      )}

      {/* Overlay dla urządzeń mobilnych */}
      {isMobile && isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={handleOverlayClick}
        ></div>
      )}

      {/* Sidebar */}
      <div className={`
        ${isMobile ? 'fixed top-0 left-0 h-full z-40 transform transition-transform duration-300 ease-in-out' : ''}
        ${isMobile && !isSidebarOpen ? '-translate-x-full' : 'translate-x-0'}
      `}>
        <Sidebar onLogout={onLogout} onClose={() => setIsSidebarOpen(false)} />
      </div>

      {/* Główna zawartość */}
      <main className={`flex-1 p-6 overflow-auto ${isMobile ? 'mt-16' : ''}`}>
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout; 